<div class="export-view-wrapper">
  <div class="close-btn-wrapper">
    <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close>
  </div>
  <div class="header">
    <div class="parameter-details-wrapper fh">
      <div class="criticality" [ngClass]="{
                                'aa':item?.classification === 'AA',   
                                 'a':item?.classification === 'A',   
                                 'b':item?.classification === 'B',   
                                 'c':item?.classification === 'C' 
                              }">
        <span>{{item?.classification}}</span>
      </div>
      <div class="main-dtls">
        <div class="param-name" [matTooltip]="item?.parametername">
          <span>{{item?.parametername}}</span>
        </div>
      </div>
    </div>
    <div class="granularity-details-wrapper">
      <div class="location-wrapper">
        <img src="assets/images/location.svg" alt="Location">
        <span class="location">
          {{item?.clusterFactoryDtls?.clusterName}}
        </span>
      </div>
      <div class="factory-wrapper">
        <img src="assets/images/factory.svg" alt="Factory">
        <span class="factory">
          {{item?.clusterFactoryDtls?.factoryName}}
        </span>
      </div>
    </div>
  </div>
  <div class="filter-details-wrapper">
    <div class="filter-item">
      <div class="item-label">
        {{'common.line' | translate}}
      </div>
      <div class="item-value">
        {{item.linename}}
      </div>
    </div>
    <div class="filter-item">
      <div class="item-label">
        {{'common.machine' | translate}}
      </div>
      <div class="item-value">
        {{item.machinename}}
      </div>
    </div>
    <div class="filter-item">
      <div class="item-label">
        {{'traceability.downloads.period' | translate}}
      </div>
      <div class="item-value">
        {{period}}
      </div>
    </div>
    <div class="filter-item">
      <div class="item-label">
        {{'common.sku' | translate}}
      </div>
      <div class="item-value">
        @if (skutext) {
        <span>{{skutext}}</span>
        }
        @if (!skutext) {
        <span>All SKUs</span>
        }
      </div>
    </div>
  </div>
  <div class="kpi-dtls-wrapper">
    @if (!item?.isGA) {
    <div class="kpi lcl">
      <span class="label">{{'common.lcl' | translate}}:</span>
      <span class="value">{{$any(item)?.kpi?.lcl?.toFixed(2)}}</span>
    </div>
    <div class="kpi ucl">
      <span class="label">{{'common.ucl' | translate}}:</span>
      <span class="value">{{$any(item)?.kpi?.ucl?.toFixed(2)}}</span>
    </div>
    <div class="separator"></div>
    <div class="kpi lsl">
      <span class="label">{{'common.lsl' | translate}}:</span>
      <span class="value">{{$any(item)?.kpi?.lsl?.toFixed(2)}}</span>
    </div>
    <div class="kpi usl">
      <span class="label">{{'common.usl' | translate}}:</span>
      <span class="value">{{$any(item)?.kpi?.usl?.toFixed(2)}}</span>
    </div>
    <div class="kpi sd">
      @if (data.isCapability) {
      <span class="label">{{'common.sigma' | translate}}:</span>
      }
      @if (!data.isCapability) {
      <span class="label">{{'common.sd' | translate}}:</span>
      }
      <span class="value">{{$any(item)?.kpi?.sigmaval?.toFixed(2)}}</span>
    </div>
    <div class="kpi cp">
      @if (data.isCapability) {
      <span class="label">{{'common.cp' | translate}}:</span>
      }
      @if (!data.isCapability) {
      <span class="label">{{'common.pp' | translate}}:</span>
      }
      @if ($any(item)?.kpi?.sigmaval!==0 && !($any(item)?.kpi?.xcp === null)) {
      <span class="value">
        {{$any(item)?.kpi?.xcp?.toFixed(2)}}
      </span>
      }
      @if ($any(item)?.kpi?.sigmaval===0 || $any(item)?.kpi?.xcp === null) {
      <span class="infinity">
        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
      </span>
      }
    </div>
    <div class="kpi cpk">
      @if (data.isCapability) {
      <span class="label">{{'common.cpk' | translate}}:</span>
      }
      @if (!data.isCapability) {
      <span class="label">{{'common.ppk' | translate}}:</span>
      }
      @if ($any(item)?.kpi?.sigmaval!==0 && !($any(item)?.kpi?.xcpk === null)) {
      <span class="value">
        {{$any(item)?.kpi?.xcpk?.toFixed(2)}}
      </span>
      }
      @if ($any(item)?.kpi?.sigmaval===0 || $any(item)?.kpi?.xcpk === null) {
      <span class="infinity">
        <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
      </span>
      }
    </div>
    <div class="kpi avg">
      <span class="label">{{'common.avg' | translate}}:</span>
      <span class="value">{{$any(item)?.kpi?.avg?.toFixed(2)}}</span>
    </div>
    }
    @if (!item?.isGA) {
    <div class="kpi total">
      <span class="label">{{'common.total_data_points' | translate}}:</span>
      @if (data.isCapability) {
      <span class="value">{{$any(item)?.kpi?.totalPoints}}</span>
      }
      @if (!data.isCapability) {
      <span class="value">{{$any(item)?.kpi?.totalDataPoints}}</span>
      }
    </div>
    }
  </div>
  @if (item?.isGA) {
  <div class="ga-summary-wrapper">
    <table class="ga-kpi-summary-table">
      <thead>
        <tr>
          <th style="width: 140px;">Variant</th>
          <th>LSL</th>
          <th>USL</th>
          <th>Target Volume</th>
          <th>Actual Packed</th>
          <th>Excess Give Away</th>
          <th>Excess GA%</th>
          <th>LSL Reject %</th>
          <th>Total Data Points</th>
        </tr>
      </thead>
      <tbody>
        @for (summary of gaSummaryRows; track summary.gaVariant) {
        <tr>
          <td>{{summary.gaVariant}}</td>
          <td>{{summary.lsl?.toFixed(2)}}</td>
          <td>{{summary.usl?.toFixed(2)}}</td>
          <td>{{summary.targetVolume?.toFixed(2)}}</td>
          <td>{{summary.actualPacked?.toFixed(2)}}</td>
          <td>{{summary.giveAway?.toFixed(2)}}</td>
          <td>{{formatGaMetric(summary.giveAwayPercentage, 4)}}</td>
          <td>{{formatGaMetric(summary.lslRejectPercentage, 4)}}</td>
          <td>{{summary.totalDataPoints}}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
  <div class="data-table-wrapper" [hidden]="!dataSource?.data?.length">

    <table mat-table class="full-width-table spc-table preview-table" [dataSource]="dataSource" matSort
      aria-label="Elements">
      @if (!data.isCapability) {
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef id="time">{{'common.time' | translate}}</th>
        <td mat-cell *matCellDef="let row" class="col1">
          {{row.convertedTS | date:'MMM d, y, HH:mm'}}
        </td>
      </ng-container>
      }
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef id="value">{{'common.value' | translate}}</th>
        <td mat-cell class="right-align col2" *matCellDef="let row">{{row.value}}</td>
      </ng-container>
      <ng-container matColumnDef="batch">
        <th mat-header-cell *matHeaderCellDef id="batch">{{'common.batch' | translate}}</th>
        <td mat-cell class="center-align table-fit" *matCellDef="let row">{{row.batch}}</td>
      </ng-container>
      <ng-container matColumnDef="outliers">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="outlier">{{'common.outlier' | translate}}
        </th>
        <td mat-cell class="center-align table-fit" *matCellDef="let row">
          {{(row.outlier||row.manualOutlier)?'true':'false'}}</td>
      </ng-container>
      <ng-container matColumnDef="rule1">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="rule1">{{'common.rule1_violation' |
          translate}}</th>
        <td mat-cell class="center-align table-fit" *matCellDef="let row">{{row.ruleViolation1}}</td>
      </ng-container>
      <ng-container matColumnDef="rule6">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="rule6">{{'common.rule6_violation' |
          translate}}</th>
        <td mat-cell class="center-align table-fit" *matCellDef="let row">{{row.ruleViolation6}}</td>
      </ng-container>
      <ng-container matColumnDef="rule7">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="rule7">{{'common.rule7_violation' |
          translate}}</th>
        <td mat-cell class="center-align table-fit" *matCellDef="let row">{{row.ruleViolation7}}</td>
      </ng-container>
      <ng-container matColumnDef="comment">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="rule8">{{'common.outlier_comment' |
          translate}}
        </th>
        <td mat-cell class="center-align table-fit col7 " *matCellDef="let row">{{row.comment}}</td>
      </ng-container>
      <ng-container matColumnDef="userID">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="userid">{{'common.outlier_userId' |
          translate}}
        </th>
        <td mat-cell class="center-align table-fit col9" *matCellDef="let row">{{row.userEmail}}</td>
      </ng-container>
      <ng-container matColumnDef="userName">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="username">{{'common.outlier_userName' |
          translate}}</th>
        <td mat-cell class="center-align table-fit  spacer" *matCellDef="let row">{{row.userNameOutlier}}</td>
      </ng-container>
      <ng-container matColumnDef="manualEntryComment">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="manualEntryComment">
          {{'common.other_comment' |
          translate}}
        </th>
        <td mat-cell class="center-align table-fit col7 " *matCellDef="let row">{{row.manualEntryComment}}</td>
      </ng-container>
      <ng-container matColumnDef="userEmail">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="userEmail">{{'common.other_userId' |
          translate}}
        </th>
        <td mat-cell class="center-align table-fit col9" *matCellDef="let row">{{row.userId}}</td>
      </ng-container>
      <ng-container matColumnDef="manualUserName">
        <th mat-header-cell class="center-align" *matHeaderCellDef id="manualUserName">{{'common.other_userName'
          |
          translate}}</th>
        <td mat-cell class="center-align table-fit  spacer" *matCellDef="let row">{{row.userName}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div class="footer-wrapper">
    <button mat-raised-button class="spc-btn" color="primary" (click)="documentDownload()">
      {{'common.download' | translate}}
    </button>
  </div>
</div>